const state = {
  currentUser: null,
  referrer: null
};

export default state;
